<template>
	<v-snackbar
		:color="color"
		:timeout="timer"
		bottom
		flat
		v-model="show"
		class="text-center"
		elevation="24"
		style="opacity: 0.9"
	>
		<div class="text-center overline">
			<v-progress-circular
				size="32"
				indeterminate
				class="mr-6"
				v-if="isLoading"
			/>
			{{ message }}
		</div>
	</v-snackbar>
</template>

<script>
// import EventBus from '@/helpers/eventbus'

export default {
	name: 'SyncStatus',
	data() {
		return {
			show: false,
			message: '',
			color: 'success',
			timer: -1,
			isLoading: null,
		}
	},
	methods: {
		showMessage: function (params) {
			this.message = params.text
			this.color = params.type
			this.timer = params.timeout || 1500
			this.show = true
			this.isLoading = params.isLoading
		},
	},
}
</script>